import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('Atlantic/Azores');

@Pipe({
    name: 'pipeDate'
})
export class PipeDate implements PipeTransform {
    transform(date: string): string {
        return moment(date).format('DD/MM/YYYY')
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeDate.ts